import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useCustomerQuery } from "@/hook/Dictionaries/Customers/useCustomerQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"

import { USERS_KEY } from "@/types/IUser"
import { FilterField, FilterFieldOperator, FilterFieldType } from "@/types/ui"


export const useUsersFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: USERS_KEY
  })

  const oldFilters: FieldData[] = getFilter()
  
  const { data: customers } = useCustomerQuery()

  useEffect(() => {
    const newFilters: FilterField[] = [
      ...UserFilters
    ]

    setFilters(newFilters)
  }, [customers])

  return mapFilters(filters, oldFilters)
}

const UserFilters: FilterField[] = [
{
    text: "Логин",
    name: "login",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  },
  {
    text: "Имя",
    name: "firstName",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  },
  {
    text: "Фамилия",
    name: "lastName",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  },
  {
    text: "Электронная почта",
    name: "email",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  },
  {
    text: "Телефон",
    name: "phone",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  },
  {
    text: "Показать архивных пользоваталей",
    name: "enabled",
    type: FilterFieldType.Checkbox,
    operator: FilterFieldOperator.NotEqual
  }
]